import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, MessageCircleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageCTA } from '../components/PageCTA';
const faqs = [{
  question: '¿Qué incluye exactamente la oferta de 350 €?',
  answer: 'La oferta reúne una página web profesional, carta digital cuando aplica, diseño responsive, gestión y mantenimiento integral. Es un pago único de 350 € (EUR), sin cuotas mensuales ni costes ocultos.'
}, {
  question: '¿Cómo se realiza el pago?',
  answer: 'El pago es online y se completa en el entorno seguro de nuestro proveedor de pagos; no almacenamos datos de tarjeta. Los impuestos aplicables se calculan según el país de facturación y se muestran antes de confirmar la compra. Estamos finalizando la activación de la pasarela: mientras tanto, puedes iniciar el pedido desde el checkout y te acompañamos por correo para completarlo.'
}, {
  question: '¿Puedo cancelar y recuperar mi dinero?',
  answer: 'Sí. Si cancelas antes de que comiencen los trabajos, devolvemos el 100% del importe. Una vez iniciada la personalización, se valora la devolución proporcional del trabajo no realizado; tras la entrega el servicio se considera prestado. El detalle completo está en la Política de Reembolsos.'
}, {
  question: '¿Cuánto suele durar el proceso?',
  answer: 'El tiempo depende de la complejidad y de la disponibilidad de materiales. Como referencia de planificación, un proyecto suele requerir entre dos y cuatro semanas desde que contamos con la información necesaria.'
}, {
  question: '¿Qué tengo que preparar antes de empezar?',
  answer: 'Necesitamos entender tu negocio, servicios, público y prioridades. Si ya tienes textos, logo o imágenes, ayudan a avanzar. Si no, definimos contigo qué información es imprescindible antes de diseñar.'
}, {
  question: '¿La web funciona bien en móvil?',
  answer: 'Sí. Diseñamos cada pantalla desde una perspectiva responsive para que la lectura, los contenidos y los llamados a la acción funcionen correctamente en móvil, tablet y escritorio.'
}, {
  question: '¿Qué ocurre después de publicar?',
  answer: 'El proyecto no se queda abandonado tras el lanzamiento. La oferta contempla gestión y mantenimiento para que tu presencia pueda mantenerse útil cuando necesites realizar cambios.'
}, {
  question: '¿Puedo contratar solo una parte del servicio?',
  answer: 'La propuesta está pensada como un sistema completo porque las piezas funcionan mejor conectadas. Si tienes una necesidad concreta, puedes escribirnos para valorar el mejor punto de partida.'
}, {
  question: '¿Para qué negocios está pensado?',
  answer: 'Es una propuesta especialmente útil para negocios locales, servicios, hostelería y profesionales que necesitan ordenar su presencia y comunicar mejor el valor de lo que hacen.'
}];
export function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-20 sm:pt-24" data-id="element-329" data-mp="2dyed9gn4guc">
      <section className="page-header" data-id="element-330" data-mp="gcy3ei82exr1">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-331" data-mp="bca2n4u1b2jm">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-7 lg:grid-cols-[0.8fr_1.2fr] lg:items-end" data-id="element-332" data-mp="bayz964i3wt1">
            <div data-id="element-333" data-mp="u3b90dxhi0d7">
              <p className="eyebrow" data-id="element-334" data-mp="u4uq26qysfg1">Preguntas frecuentes</p>
              <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-6xl" data-id="element-335" data-mp="1913mz1ndugpa">
                Todo lo que conviene saber antes de empezar.
              </h1>
            </div>
            <p className="max-w-2xl text-base leading-relaxed text-neutral-300 sm:text-lg" data-id="element-336" data-mp="2xin1g3jkgcon">
              Hemos reunido las dudas más habituales sobre alcance, proceso,
              precio y acompañamiento.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-shell border-b border-white/10" data-id="element-337" data-mp="3c93zdcwzskgs">
        <div className="container mx-auto max-w-4xl px-6 md:px-12" data-id="element-338" data-mp="3caf35cqfts7w">
          <div className="border border-white/10" data-id="element-339" data-mp="2emdcumb1g3qe">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            const answerId = `faq-answer-${index}`;
            return <div key={faq.question} className="border-b border-white/10 last:border-b-0" data-id="element-340" data-mp="2ol2vwieo7u88" data-mpi={index}>
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={answerId} className="flex w-full items-center justify-between gap-6 p-6 text-left transition-colors hover:bg-white/[0.03] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white sm:p-7" data-id="element-341" data-mp="3tka0ozfzm70">
                    <span className="flex gap-5" data-id="element-342" data-mp="1el06xd7oycn9">
                      <span className="meta-number pt-0.5" data-id="element-343" data-mp="1ek78r0mssvgq">
                        0{index + 1}
                      </span>
                      <span className="text-base font-medium tracking-[-0.015em] text-white" data-id="element-344" data-mp="19jswt7i2t1df">
                        {faq.question}
                      </span>
                    </span>
                    <ChevronDownIcon size={18} className={`shrink-0 text-neutral-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-345" data-mp="10lhavis5mrrb" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-346" data-mp="2q1gp3eamr7dt">
                    {isOpen && <motion.div id={answerId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.24,
                  ease: 'easeOut'
                }} data-id="element-347" data-mp="o9ydwg60a535">
                        <p className="max-w-2xl px-6 pb-7 pl-14 text-sm leading-relaxed text-neutral-300 sm:px-7 sm:pb-8 sm:pl-[4.9rem]" data-id="element-348" data-mp="122e9ivwkv0u1">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="section-shell border-b border-white/10 bg-black" data-id="element-349" data-mp="24wtl23irbdbh">
        <div className="container mx-auto max-w-5xl px-6 md:px-12" data-id="element-350" data-mp="1zvnp7wtsv9xq">
          <div className="grid overflow-hidden border border-white/10 md:grid-cols-[1fr_auto]" data-id="element-351" data-mp="2duncb01nzgrs">
            <div className="p-8 sm:p-10" data-id="element-352" data-mp="29v4tc9telfrl">
              <p className="eyebrow" data-id="element-353" data-mp="29rz1wnxay1sp">¿Sigues con dudas?</p>
              <h2 className="mt-5 text-3xl font-medium tracking-[-0.04em] text-white" data-id="element-354" data-mp="1m5k6vgy1k0dk">
                Hablemos de tu caso concreto.
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-neutral-300" data-id="element-355" data-mp="1h3l70h1iflld">
                Una conversación breve puede ayudarte a entender si este es el
                momento y el alcance adecuado para tu negocio.
              </p>
            </div>
            <div className="flex items-center border-t border-white/10 p-8 md:border-l md:border-t-0" data-id="element-356" data-mp="12eypq9sbojri">
              <Link to="/contacto" className="button-secondary w-full" data-id="element-357" data-mp="yeerf2w0ja3s">
                <MessageCircleIcon size={16} aria-hidden="true" data-id="element-358" data-mp="1naqwwhxch9zo" /> Contactar
              </Link>
            </div>
          </div>
        </div>
      </section>
      <PageCTA data-id="element-359" data-mp="1samzqdub2vdn" />
    </div>;
}